<template>
  <div id="contenedor-contrato-videos-tool-bar">
    <v-toolbar flat color="transparent">
      <v-spacer></v-spacer>
      <custom-button
        v-if="mixValidaScopesActions(1)"
        label="Nuevo"
        iconText="mdi-plus"
        tipo="agregar"
        @click="nuevoVideo">
      </custom-button>
    </v-toolbar>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'ContratoVideosToolBar',
  components: {
    CustomButton,
  },
  data() {
    return {};
  },
  methods: {
    nuevoVideo() {
      this.$emit('nuevoVideo');
    },
  },
};
</script>

<style lang="scss">

</style>
